<template>
  <v-layout wrap style="position: relative; min-height: 280px">
    <v-flex xs12 sm6 class="pa-1">
      <v-divider></v-divider>
      <div class="mt-3 mb-2 subtitle primary--text">
        {{ $t('This message will be sent within 24 hours after order summary.') }}
      </div>
      <template v-if="value.follow_up_cart">
        <PaymentFollowupMessageAfterSummary v-model="value.follow_up_cart" :isEdit="isEdit" />
      </template>
    </v-flex>
    <v-flex xs12 sm6 class="pa-1">
      <v-divider></v-divider>
      <div class="mt-3 mb-2 subtitle primary--text">
        {{
          $t(
            'This message will be sent to provide after-sales service within 24 hours when customer get order No.'
          )
        }}
      </div>
      <template v-if="value.follow_up_order">
        <PaymentFollowupMessageAfterSummary v-model="value.follow_up_order" :isEdit="isEdit" />
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import PaymentFollowupMessageAfterSummary from './PaymentFollowupMessageAfterSummary'
export default {
  props: {
    value: {},
    isEdit: {}
  },
  data() {
    return {
      showPreview: false,
      followup: {
        status: false
      }
    }
  },
  components: {
    PaymentFollowupMessageAfterSummary
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PaymentFollowupContainerAfterSummary.vue